export default __webpack_public_path__ + "static/media/SCAN_package_target.d9c174b0.svg";